import MpkAdminStartPage from './MpkAdminStartPage';

export default MpkAdminStartPage;
